export const wordList = {
  assasino: ['zed', 'katarina'],
  mago: ['lux', 'syndra'],
  adc: ['vayne', 'tristana'],
  utility: ['lulu', 'karma', 'ivern'],
  tanque: ['volibear', 'maokai', 'shen'],
}